import { useGetMotivationDetailQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

export const useMotivationDetails = (motivationId: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetMotivationDetailQuery(
    { motivationId: motivationId ?? '', networkId: networkId ?? undefined, month: month ?? undefined },
    { skip: !motivationId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
